<template>
  <el-table
    :data="currencies"
    max-height="250"
    style="width: 100%"
    v-loading="loading"
    :default-sort="{prop: 'name', order: 'ascending'}"
  >
    <el-table-column
      prop="name"
      label="Név"
    />
    <el-table-column
      fixed="right"
      label=""
      width="120"
    >
      <template slot-scope="scope">
        <Actions :currency="scope.row" />
      </template>
    </el-table-column>
  </el-table>
</template>
<script>
  import Actions from './Actions'

  export default {

    components: {
      Actions
    },

    computed: {
      currencies() {
        return this.$store.getters['currency/currencies'];
      },

      loading() {
        return this.$store.getters['currency/loading'];
      }
    },

    async mounted() {
      await this.$store.dispatch('currency/fetchAll');
    },
  }
</script>
